import React from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

const CONFIG = {
  PENDING:     { cls: 'bg-yellow-100 text-yellow-700 border border-yellow-200', dot: 'bg-yellow-500', label: 'Pending' },
  IN_PROGRESS: { cls: 'bg-blue-100 text-blue-700 border border-blue-200',   dot: 'bg-blue-500',   label: 'In Progress', spin: true },
  GENERATED:   { cls: 'bg-green-100 text-green-700 border border-green-200',  dot: 'bg-green-500',  label: 'Generated' },
  FAILED:      { cls: 'bg-red-100 text-red-700 border border-red-200',     dot: 'bg-red-500',    label: 'Failed' },
};

export default function ReportStatusBadge({ status }) {
  const cfg = CONFIG[status] ?? { cls: 'bg-gray-100 text-gray-600 border border-gray-200', dot: 'bg-gray-400', label: status };
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${cfg.cls}`}>
      {cfg.spin
        ? <ArrowPathIcon className="w-3 h-3 animate-spin" />
        : <span className={`w-1.5 h-1.5 rounded-full ${cfg.dot}`} />
      }
      {cfg.label}
    </span>
  );
}
